import { useState, useEffect } from "react";
import { useRouter } from "next/router";

export const useEmbed = () => {
  const router = useRouter();
  const [isEmbed, setIsEmbed] = useState(false);

  useEffect(() => {
    setIsEmbed(router.asPath.includes("embed"));
  }, []);

  return isEmbed;
};
